export const ENVIRONMENT_URLS = {
  prod: {
    configApiBaseUrl: 'https://staffapp.ireckonu.com',
    idpBaseUrl: 'https://iru-idp-prod.ireckonu.com',
  },
  acc: {
    configApiBaseUrl: 'https://staffapp-acc.ireckonu.com',
    idpBaseUrl: 'https://iru-idp-acc.ireckonu.com',
  },
} as const;
